import { Component } from '@angular/core';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { AsyncPipe, NgIf } from '@angular/common';
import { NzMenuDirective, NzMenuItemComponent } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { StoreService } from './store/store.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf,
    AsyncPipe,
    NzMenuItemComponent,
    NzMenuDirective,
    NzLayoutModule,
    NzIconModule,
    RouterLink,
    RouterLinkActive,
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isLoggedIn$: Observable<boolean>;
  loggedInName$: Observable<string | null>;

  constructor(
    private router: Router,
    private readonly store: StoreService,
  ) {
    this.isLoggedIn$ = store.select((state) => state.auth.loggedIn);
    this.loggedInName$ = store.select((state) => state.auth.displayName);
  }

  navigateToRoot() {
    this.router.navigateByUrl('/');
  }

  logout() {
    this.store.getActions().auth.logOut();
    this.router.navigateByUrl('/');
  }
}
